<!-- 上传多个图片 -->
<template>
  <div>
    <div
      class="upload-box"
      :class="{ 'upload-small': isHideUpload, 'upload-normal': !isHideUpload }"
      v-if="!isOnlyPreview"
    >
      <el-upload
        action
        class="upload-demo"
        list-type="picture-card"
        accept="image/*"
        :limit="limitCount"
        :file-list="explainImgList"
        :on-remove="handleRemove"
        :on-success="handleUploadSuccess"
        :before-upload="beforeAvatarUpload"
        :on-exceed="handleExceed"
        :on-error="handleUploadError"
        :http-request="upload"
        :disabled="disabled"
        :on-preview="handlePictureCardPreview"
        :on-change="onChange"
        :class="{ hide: hideUpload }"
      >
        <i class="el-icon-plus"></i>
      </el-upload>
      <!-- 图片预览 -->
      <el-image
        :src="curImageUrl"
        :preview-src-list="prevImgsList"
        ref="prevImgRef"
        class="upload-box_prev"
      ></el-image>
    </div>
    <div class="only-preview" v-else>
      <el-image
        v-for="(img, ind) in explainImgList"
        :key="ind"
        :src="img.url"
        :preview-src-list="[img.url]"
      >
      </el-image>
      <div v-if="_.isEmpty(explainImgList)">-</div>
    </div>
  </div>
</template>
<script>
import { uploadFile } from "@/api/common";
export default {
  props: {
    //最新的图片数组
    upLoadImgList: {
      type: Array,
      default: () => []
    },
    //是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    //张数限制
    limitCount: {
      type: Number,
      default: 1
    },
    //图片上传限制大小
    limitSize: {
      type: Number,
      default: 10
    },
    //隐藏上传按钮 只显示一张图片主要用于头像上传的时候
    isHideUpload: {
      type: Boolean,
      default: false
    },
    //仅支持预览
    isOnlyPreview: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      explainImgList: [],
      curImageUrl: "", //当前预览图片路径
      prevImgsList: [], //图片预览
      hideUpload: false
    };
  },
  watch: {
    upLoadImgList: {
      handler(newVal, oldVal) {
        if (_.isEmpty(newVal)) {
          this.explainImgList = [];
        } else {
          // 如果是字符串数组则需要处理成upload组件能识别的格式
          let newVals = [];
          _.cloneDeep(newVal).forEach(item => {
            const isString =
              Object.prototype.toString.call(item) === "[object String]";
            let newItem = {};
            if (isString) {
              newItem = {
                name: item,
                // url: this.getSeverFileUrl(item),
                url: item,
                uid: _.uniqueId()
              };
            } else {
              newItem = {
                name: item.name ? item.name : item,
                // url: item.url ? item.url : this.getSeverFileUrl(item),
                url: item.url ? item.url : item,
                uid: item.uid ? item.uid : _.uniqueId()
              };
            }
            newVals.push(newItem);
          });
          this.explainImgList = newVals;
        }
        this.handleUpload(newVal);
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    if (!this.upLoadImgList) return;
    if (this.upLoadImgList.length < 1) {
      this.explainImgList = [];
    } else {
      this.explainImgList = this.upLoadImgList;
    }
  },
  methods: {
    onChange(file, fileList) {
      this.handleUpload(fileList);
    },
    // 移除图片
    handleRemove(file, fileList) {
      this.explainImgList = fileList;
      this.handleUpload(fileList);
      const newFilesLists = _.map(_.cloneDeep(this.explainImgList), o =>
        _.pick(o, ["name", "url", "uid"])
      );
      this.$emit("upLoadImgList", newFilesLists);
    },
    //是否需要隐藏上传组件
    handleUpload(fileList) {
      if (this.isHideUpload) {
        this.hideUpload = fileList.length >= this.limitCount;
      }
    },

    // 文件上传之前调用做一些拦截限制
    beforeAvatarUpload(file, fileList) {
      const isLtSize = file.size / 1024 / 1024 < this.limitSize;
      if (!isLtSize)
        this.$modal.msgWarning(`上传的图片大小不能超过${this.limitSize}MB!`);
      return isLtSize;
    },

    // 图片上传成功回调 在这里传值给父组件
    handleUploadSuccess(res, file, fileList) {
      if (res && !_.isEmpty(res.data)) {
        const curFile = {
          name: res.data[0],
          // url: this.getSeverFileUrl(res.data[0]),
          url: res.data.fileLook[0],
          uid: file.uid ? file.uid : _.uniqueId()
        };

        this.explainImgList.push(curFile);
        const newFilesLists = _.map(_.cloneDeep(this.explainImgList), o =>
          _.pick(o, ["name", "url", "uid"])
        );
        this.$emit("upLoadImgList", newFilesLists);
      }
      this.$modal.closeLoading();
    },
    // 文件大小限制
    handleExceed(files, fileList) {
      this.$modal.msg(`上传图片数量不能超过${this.limitCount}张`);
    },
    handleUploadError(err, file, fileList) {
      this.$modal.closeLoading();
      this.$modal.msgWarning("上传图片失败，请重试");
    },
    //预览图片
    handlePictureCardPreview(file) {
      this.curImageUrl = file.url;
      this.prevImgsList = [file.url];
      this.$refs.prevImgRef.showViewer = true;
    },
    async upload(file) {
      if (this.isHideUpload) {
        this.hideUpload = true;
      }
      const fileArray = [];
      const form = new FormData();
      fileArray.push(file.file);
      fileArray.forEach((item, index) => {
        form.append("files", fileArray[index]);
      });
      this.$modal.loading("正在上传图片，请稍候...");
      const res = await uploadFile(form);

      if (res.code == 200) {
        file.onSuccess(res);
      } else {
        this.$modal.closeLoading();
        this.$modal.msgWarning(res.msg);
      }
    }
  }
};
</script>

<style scoped lang="less">
.upload-box {
  position: relative;
  &_prev {
    position: absolute;
    z-index: -1;
  }
}
.only-preview {
  .el-image {
    border-radius: 4px;
    margin-right: 5px;
    width: 137px;
    height: 137px;
  }
}
.upload-normal {
  // 改变图片上传前大小
  ::v-deep .el-upload--picture-card {
    width: 136px;
    height: 136px;
    line-height: 136px;
    border-radius: 4px;
    background: #f6f7fb;
    border: none !important;
  }
  // 改变图片上传后大小
  ::v-deep .el-upload-list--picture-card .el-upload-list__item {
    width: 136px;
    height: 136px;
  }
}
.upload-small {
  // 改变图片上传前大小
  ::v-deep .el-upload--picture-card {
    width: 78px;
    height: 78px;
    line-height: 78px;
    border-radius: 4px;
    background: #f6f7fb;
    border: 1px dashed #dbdbdb;
  }
  // 改变图片上传后大小
  ::v-deep .el-upload-list--picture-card .el-upload-list__item {
    width: 78px;
    height: 78px;
  }

  ::v-deep .el-upload-list--picture-card .el-upload-list__item {
    margin: 0;
  }
}
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
</style>
